"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.76,0H2.24a.56.56,0,0,0-.63.64V20.15a.56.56,0,0,0,.63.64H8.63l3.21,3.15a.24.24,0,0,0,.32,0l3.21-3.15h6.39a.56.56,0,0,0,.63-.64V.64A.56.56,0,0,0,21.76,0Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.54,6.51l3,1.24,3.37-1.46L10.34,4.82a.3.3,0,0,0-.26,0l-2.54,1a.34.34,0,0,0-.21.32A.35.35,0,0,0,7.54,6.51Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20,6.29a1.73,1.73,0,0,0-2.25-.92l-9.26,4-1.92-1a.36.36,0,0,0-.29,0l-2.41,1a.32.32,0,0,0-.2.25.34.34,0,0,0,.1.3l3.09,3.1a.34.34,0,0,0,.37.08l4.44-1.78L9.88,16.19a.34.34,0,0,0,.09.37.35.35,0,0,0,.23.09.41.41,0,0,0,.16,0l2.75-1.38a.31.31,0,0,0,.15-.15L16,9.7l3.11-1.16A1.71,1.71,0,0,0,20,6.29Z",
    style: {
      fill: '#fff'
    }
  }));
};

exports["default"] = _default;